import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.884 6.028a1.13 1.13 0 0 0 0 1.581l1.807 1.808a1.13 1.13 0 0 0 1.582 0l4.258-4.259a6.777 6.777 0 0 1-8.969 8.969l-7.805 7.805a2.396 2.396 0 0 1-3.388-3.389l7.805-7.805a6.777 6.777 0 0 1 8.968-8.968l-4.247 4.247-.011.011Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }